import * as React from 'react';
import { calloutDense, calloutRoot, calloutVariant } from 'ui/Callout/calloutStylesCssDefs';
import Typography from 'ui/Typography';

export type CalloutVariant =
  | 'default'
  | 'internal'
  | 'negative'
  | 'positive'
  | 'subtle'
  | 'warning';

export interface CalloutProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  disableTypography?: boolean;
  isDense?: boolean;
  variant?: CalloutVariant;
}

/**
 * Component used to render a short message on a colored background to
 * draw attention to the contents.
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Callout: React.FunctionComponent<React.PropsWithChildren<CalloutProps>> = ({
  variant = 'default',
  children,
  disableTypography,
  isDense,
  className,
  ...rest
}) => {
  return (
    <div
      className={className}
      role="status"
      css={[calloutRoot, (Theme) => calloutVariant(Theme, variant), isDense ? calloutDense : null]}
      {...rest}
    >
      {disableTypography ? (
        children
      ) : (
        <Typography variant="body2Regular" component="p">
          {children}
        </Typography>
      )}
    </div>
  );
};

export default Callout;
